import React from 'react';
import { View } from 'react-native';
import { createShimmerPlaceholder } from 'react-native-shimmer-placeholder';
import LinearGradient from 'react-native-linear-gradient';
const ShimmerTable = () => {
    const ShimmerPlaceholder = createShimmerPlaceholder(LinearGradient);
    return (React.createElement(View, { style: {
            width: '100%',
            height: '100%',
            flexDirection: 'column',
            paddingHorizontal: 16,
            paddingTop: 16
        } },
        React.createElement(View, { style: {
                flexDirection: "column",
                width: '100%',
                height: '100%',
                paddingHorizontal: 16,
                paddingTop: 16,
                backgroundColor: '#F9FAFB'
            } },
            React.createElement(ShimmerPlaceholder, { style: {
                    width: '100%',
                    borderRadius: 8,
                    height: 100
                } }),
            React.createElement(ShimmerPlaceholder
            // stopAutoRun
            , { 
                // stopAutoRun
                style: {
                    width: '100%',
                    height: 100,
                    marginTop: 28,
                    borderRadius: 8,
                } }),
            React.createElement(ShimmerPlaceholder
            // stopAutoRun
            , { 
                // stopAutoRun
                style: {
                    width: '100%',
                    height: 100,
                    marginTop: 28,
                    borderRadius: 8,
                } }),
            React.createElement(ShimmerPlaceholder
            // stopAutoRun
            , { 
                // stopAutoRun
                style: {
                    width: '100%',
                    height: 100,
                    marginTop: 28,
                    borderRadius: 8,
                } }),
            "  ",
            React.createElement(ShimmerPlaceholder
            // stopAutoRun
            , { 
                // stopAutoRun
                style: {
                    width: '100%',
                    height: 100,
                    marginTop: 28,
                    borderRadius: 8,
                } }),
            "  ",
            React.createElement(ShimmerPlaceholder
            // stopAutoRun
            , { 
                // stopAutoRun
                style: {
                    width: '100%',
                    height: 100,
                    marginTop: 28,
                    borderRadius: 8,
                } }),
            "  ",
            React.createElement(ShimmerPlaceholder
            // stopAutoRun
            , { 
                // stopAutoRun
                style: {
                    width: '100%',
                    height: 100,
                    marginTop: 28,
                    borderRadius: 8,
                } }))));
};
export default ShimmerTable;
